export default __webpack_public_path__ + "assets/images/55827fa5a5795d27a063060e70f0b8a0.png";